<template>
  <section class="header__nav">
    <ul class="nav-list">
      <div
        class="line"
        :style="{
          width: width + 'px',
          left: left + 'px'
        }"
      ></div>

      <li
        v-for="(item, index) in dataList"
        :key="index"
        :class="{ 'acitve-item': item.key === activeItem }"
        class="nav-list__item"
        @mouseover="handleHover($event)"
        @mouseleave="handleLeave($event)"
      >
        <p v-if="!item.children">
          <a :href="item.path" v-if="item.path">{{ item.name }}</a>
          <router-link v-else :to="{ name: item.key }"
            ><p>{{ item.name }}</p></router-link
          >
        </p>

        <p v-else>{{ item.name }}<Icon type="ios-arrow-down" /></p>
        <ul class="sub-nav" v-if="item.children">
          <li
            v-for="(cell, i) in item.children"
            :key="i"
            :class="{ active: activeKey === cell.key }"
          >
            <router-link :to="{ name: cell.key }">{{ cell.name }}</router-link>
          </li>
        </ul>
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  data() {
    return {
      activeItem: "",
      activeKey: "",
      width: 80,
      left: 0,
      dataList: [
        {
          name: "首页",
          key: "home"
        },
        {
          name: "文档中心",
          key: "doc-center",
          children: [
            {
              name: "API文档",
              key: "docApi"
            },
            {
              name: "技术文档",
              key: "docTechnology"
            },
            {
              name: "产品文档",
              key: "docProduct"
            }
          ]
        },
        {
          name: "平台公告",
          key: "docNotice"
        },
        {
          name: "常用工具",
          key: "test"
        },
        {
          name: "帮助支持",
          key: "doc-help",
          children: [
            {
              name: "常见问题",
              key: "docFaq"
            }
          ]
        },
        {
          name: "控制台",
          key: "control",
          path: "/control"
        }
      ]
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.updateNav();
    this.$nextTick(() => {
      this.init();
    });
  },
  watch: {
    $route() {
      this.updateNav();
      this.$nextTick(() => {
        this.init();
      });
    }
  },
  methods: {
    init() {
      let $activeItem = document.querySelector(".acitve-item");
      if (!$activeItem) return;
      this.width = $activeItem.offsetWidth;
      this.left = $activeItem.offsetLeft;
    },
    updateNav() {
      const name = this.$route.name;
      let list = {
        docApiInfo: "docApi",
        docTechnology: "docTechnology",
        docTechnologyInfo: "docTechnology",
        docTechnologyList: "docTechnology",

        docProduct: "docProduct",
        docProductInfo: "docProduct",
        docProductList: "docProduct",
        docFaq: "docFaq",
        docFaqInfo: "docFaq",
        docFaqList: "docFaq",
        docNotice: "docNotice",
        docNoticeList: "docNotice",
        docNoticeInfo: "docNotice",
        test: "test",
        "api-test": "test",
        "error-code-test": "test",

        home: "home"
      };
      this.activeKey = list[name];
      this.dataList.forEach(item => {
        let c = null;

        if (item.children) {
          c = item.children.some(cell => cell.key === this.activeKey) || false;
        } else {
          c = item.key === this.activeKey;
        }
        c && (this.activeItem = item.key);
      });
    },
    handleHover(e) {
      let $hoverItem = e.currentTarget;
      this.width = $hoverItem.offsetWidth;
      this.left = $hoverItem.offsetLeft;
    },
    handleLeave(e) {
      this.init();
    }
  },
  components: {}
};
</script>

<style lang="less">
.header__content {
  .header__nav {
    height: 100%;
    margin-left: 96px;
    color: @color-font-label;
    .nav-list {
      display: flex;
      align-items: center;
      position: relative;
      .line {
        position: absolute;
        left: 0px;
        top: 0px;
        height: 4px;
        background: @color-primary;
        width: 80px;
        transition: all 0.5s;
      }
      .nav-list__item {
        padding: 0px 0px;
        width: 130px;
        cursor: pointer;
        position: relative;
        height: 56px;
        display: flex;
        align-items: center;
        justify-content: center;

        a {
          display: block;
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          text-align: center;
          justify-content: center;
          cursor: pointer;
        }
        .ivu-icon {
          margin-left: 4px;
        }
        &.acitve-item {
          p {
            color: @color-font-white;
          }
        }
        &:hover p {
          color: @color-font-white;
        }

        .sub-nav {
          //border-top: 2px solid @color-primary;
          margin-top: 0px;
          padding: 8px 0;
          box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.1);
          width: 172px;
          position: absolute;
          top: 100%;
          left: 0px;
          line-height: 40px;
          background: #313443;
          opacity: 0;
          pointer-events: none;
          transition: all 0.3s;
          li {
            color: @color-font-label;
            padding: 0px 18px;
            transition: all 0.3s;
            &.active {
              //background: @color-info;
              background: #3b3f51;
              color: @color-font-white;
              // padding-left: 26px;
              transition: all 0.3s;
            }
            &:hover {
              background: #3b3f51;
              color: @color-font-white;
              // padding-left: 26px;
              transition: all 0.3s;
            }
            a {
              justify-content: flex-start;
            }
          }
        }
        &:hover .sub-nav {
          opacity: 1;
          pointer-events: auto;
          transition: all 0.3s;
        }
      }
    }
  }
}
</style>
